import React from 'react';
import { FiArrowUpRight, FiGithub } from 'react-icons/fi';
import cloudNativeWebApp from '../assets/portfolio/CSYE6225 - CloudNativeWebApp.jpg';
import viralSpark from '../assets/portfolio/ViralSpark.jpeg';
import studyHub from '../assets/portfolio/StudyHub.jpeg';
import synthesize from '../assets/portfolio/synthesize.png';

const portfolios = [
  {
    id: 1,
    name: 'Cloud Native Web App',
    src: cloudNativeWebApp,
    description:
      'Production-style 3-tier application on AWS with Node.js, PostgreSQL, Pulumi, autoscaling, load balancing, observability, and GitHub Actions CI/CD.',
    tags: ['AWS', 'Node.js', 'PostgreSQL', 'Pulumi', 'CI/CD'],
    codeLink: 'https://github.com/orgs/FALL2023CSYE6225/repositories',
  },
  {
    id: 2,
    name: 'ViralSpark',
    src: viralSpark,
    description:
      'AI-assisted content generation application built with React, Next.js, TypeScript, OpenAI image generation, and Claude for text workflows.',
    tags: ['React', 'Next.js', 'TypeScript', 'OpenAI'],
    codeLink: 'https://github.com/ajitp4292/ViralSpark',
  },
  {
    id: 3,
    name: 'StudyHub',
    src: studyHub,
    description:
      'Additional software project — explore the repository for implementation details.',
    tags: ['Project'],
    codeLink: 'https://github.com/ajitp4292/StudyHub',
  },
  {
    id: 4,
    name: 'Synthesize',
    src: synthesize,
    description:
      'Additional software project — explore the repository for implementation details.',
    tags: ['Project'],
    codeLink: 'https://github.com/ajitp4292/Synthesize',
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio" className="bg-black w-full text-white py-24">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="max-w-3xl">
          <p className="text-sm uppercase tracking-[0.25em] text-cyan-400 font-semibold mb-2">
            Selected work
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold">Projects</h2>
          <p className="mt-4 text-gray-400 text-lg">
            A mix of cloud-native, full-stack, and AI-enabled work.
          </p>
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {portfolios.map((project) => (
            <article
              key={project.id}
              className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.035] transition hover:-translate-y-1 hover:border-cyan-400/30"
            >
              <div className="overflow-hidden bg-gray-900">
                <img
                  src={project.src}
                  alt={`${project.name} project preview`}
                  className="w-full h-52 object-cover transition duration-500 hover:scale-105"
                />
              </div>

              <div className="p-6">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="text-2xl font-bold">{project.name}</h3>
                  <a
                    href={project.codeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Open ${project.name} repository`}
                    className="text-gray-400 hover:text-cyan-300 transition"
                  >
                    <FiArrowUpRight size={22} />
                  </a>
                </div>

                <p className="mt-4 text-gray-400 leading-relaxed">
                  {project.description}
                </p>

                <div className="mt-5 flex flex-wrap gap-2">
                  {project.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-cyan-400/10 px-3 py-1 text-xs font-semibold text-cyan-300"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <a
                  href={project.codeLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-cyan-300 transition"
                >
                  <FiGithub /> View code
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
